import { render } from "./msg_reply.vue?vue&type=template&id=16b989b7&scoped=true"
import script from "./msg_reply.vue?vue&type=script&lang=js"
export * from "./msg_reply.vue?vue&type=script&lang=js"

import "./msg_reply.vue?vue&type=style&index=0&id=16b989b7&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16b989b7"]])

export default __exports__